import { render } from "./BtnDownloadSendReport.vue?vue&type=template&id=54032c9a"
import script from "./BtnDownloadSendReport.vue?vue&type=script&lang=js"
export * from "./BtnDownloadSendReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__